import React, { useEffect, useState, forwardRef } from 'react';
import { cn, formatNumberWithDots, parseFormattedNumber } from '~/helpers/utils';

type FormattedNumberInputProps = {
  name: string;
  value?: number;
  onChange?: (value: number) => void;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
  hasError?: boolean;
  prefixComponent?: React.ReactNode;
  suffixComponent?: React.ReactNode;
};

const FormattedNumberInput = forwardRef<HTMLInputElement, FormattedNumberInputProps>(
  (
    {
      value,
      onChange,
      onBlur,
      onKeyDown,
      placeholder,
      className,
      id,
      disabled,
      hasError,
      prefixComponent,
      suffixComponent,
    },
    ref
  ) => {
    const [displayValue, setDisplayValue] = useState('');
  
    useEffect(() => {
      if (value === null || value === undefined || isNaN(value)) {
        setDisplayValue('');
      } else {
        setDisplayValue(formatNumberWithDots(value));
      }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const input = e.target.value;
      setDisplayValue(input);

      if (!onChange) return;

      if (input === '') {
        onChange(undefined as any);
        return;
      }

      const parsed = parseFormattedNumber(input);
      if (!isNaN(parsed)) {
        onChange(parsed);
      }
    };


    return (
      <div className="relative">
        {prefixComponent || (
          <span className="absolute top-1/2 -translate-y-1/2 left-4 pointer-events-none text-blue-800">&euro;</span>
        )}
        <input
          type="text"
          value={displayValue}
          placeholder={placeholder}
          className={cn(
            'form-input !py-4',
            !prefixComponent && '!pl-8',
            hasError && 'form-input--error',
            className
          )}
          onChange={handleChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          disabled={disabled}
          id={id}
          ref={ref}
        />
        {suffixComponent}
      </div>
    );
  }
);

export default FormattedNumberInput;